import type { GuideArticle } from './articleTypes';
import { articles1 } from './articles1';
import { articles2 } from './articles2';
import { articles3 } from './articles3';

export type { GuideArticle, GuideFaq, GuideSection, LocalizedText } from './articleTypes';

export const guideArticles: GuideArticle[] = [...articles1, ...articles2, ...articles3];

export function getArticle(slug: string): GuideArticle | undefined {
  return guideArticles.find((a) => a.slug === slug);
}